export default __webpack_public_path__ + "static/media/arrow.63cc2314.svg";